var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingTwo = function SvgSettingTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 25",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.142 21.805a9.997 9.997 0 0 1-4.348-2.652 3 3 0 0 0-2.59-4.919 10.044 10.044 0 0 1 .253-5.014H2.5a3 3 0 0 0 2.692-4.325A9.984 9.984 0 0 1 9.326 2.58a3 3 0 0 0 5.348 0 9.984 9.984 0 0 1 4.134 2.314 3 3 0 0 0 2.734 4.326c.508 1.623.596 3.349.255 5.015a3 3 0 0 0-2.59 4.92 9.998 9.998 0 0 1-4.349 2.65 3 3 0 0 0-5.716 0Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.72a3.5 3.5 0 1 0 0-6.999 3.5 3.5 0 0 0 0 7Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
};
export default SvgSettingTwo;